import { DataTableDefinition } from "@/v2/types/Datatable";
import { createColumnHelper, flexRender } from "@tanstack/react-table";
import { buildColumns } from "./buildColumns";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Eye, Pencil } from "lucide-react";
import { generateFilterColumn } from "../../filter";
import AccessControl from "../../rbac/AccessControl";
import { Payslip } from "@/v2/types";
import PayslipDeleteButton from "../../ui/button/delete/Payslip";
import PrintFreelancerPayslipPDF from "../../pages/payslip/freelancer/Print";

type T = Payslip;

const columnHelper = createColumnHelper<T>();

const PayslipColumnDefintion: DataTableDefinition<T>[] = [
    {
        id: "sl",
        headingText: "Sl No",
        headingCellType: "small-cell",
        cellType: "text-center",
    },
    {
        id: "employee.full_name",
        headingText: "Employee Name",
    },
    {
        id: "total_hours",
        headingText: "Total Hour",
        headingCellType: "text-center",
        cellType: "text-center",
    },
    {
        id: "hourly_rate",
        headingText: "Hourly Rate",
        headingCellType: "text-center",
        cellType: "text-center",
    },
    {
        id: "net_amount",
        headingText: "Amount",
        headingCellType: "text-center",
        cellType: "money",
    },
    {
        id: "deduction",
        headingText: "Deduction",
        headingCellType: "text-center",
        cellType: "money",
    },
    {
        id: "actions",
        headingText: "Actions",
        headingCellType: "text-center",
        cell: ({ row }) =>
            flexRender(
                <div className="flex justify-center gap-2">
                    <Link to={`/payslips/freelancer/${row.id}`}>
                        <Button variant={"outline"} size={"sm"}>
                            <Eye className="size-4" />
                        </Button>
                    </Link>
                    <PrintFreelancerPayslipPDF payslipId={row.id} />

                    <AccessControl
                        module="PAYSLIP_MANAGEMENT"
                        requestedAccess={"PUT"}
                    >
                        <Link to={`/payslips/freelancer/edit/${row.id}`}>
                            <Button variant={"outline"} size={"sm"}>
                                <Pencil className="size-4" />
                            </Button>
                        </Link>
                    </AccessControl>

                    <AccessControl
                        module="PAYSLIP_MANAGEMENT"
                        requestedAccess={"DELETE"}
                    >
                        <PayslipDeleteButton id={row.id} />
                    </AccessControl>
                </div>,
                {},
            ),
    },
];

const PayslipColumn = buildColumns<T>(columnHelper, PayslipColumnDefintion);

const PayslipFilterColumn = generateFilterColumn<T>(PayslipColumnDefintion, {
    removeIds: [],
    renameMap: {},
});

export {
    PayslipColumn as FreelancerPayslipColumn,
    PayslipFilterColumn as FreelancerPayslipFilterColumn,
};
